module.exports = __webpack_public_path__ + "static/media/IMG_8027.d82e70e7.jpg";